import { DirectiveOptions } from 'vue';


let clickEvent = (event: Event) => { };
document.addEventListener('click', clickEvent);

let sharedElement = (className: string, sharedClass: string) => {
    //Remove shared elements
    let sharedElements = document.querySelectorAll(`.${sharedClass}`);
    sharedElements.forEach(element => {
        element.classList.remove(className);
    });
}
const directive: DirectiveOptions = {
    bind(el, binding, node) {
        el.addEventListener('click', () => {
            if ([...el.classList].indexOf(binding.value.class) === -1) {
                if (binding.value.sharedClass) {
                    sharedElement(binding.value.class, binding.value.sharedClass);
                }

                el.classList.add(binding.value.class);
            } else {
                el.classList.remove(binding.value.class);
            }
        })
        
        if(binding.value.clickOutside != "off") {
            document.removeEventListener('click', clickEvent);
    
            clickEvent = (event: Event) => {
                let a = event.target as HTMLElement;
                var els = [];
                while (a) {
                    els.unshift(a);
                    a = a.parentNode as HTMLElement;
                }
    
                if (els.map(elsEl => elsEl.className).join('').indexOf(binding.value.allow) === -1 && els.map(elsEl => elsEl.className).join('').indexOf(binding.value.sharedClass) === -1) {
                    sharedElement(binding.value.class, binding.value.sharedClass);
                }
            }
    
            document.addEventListener('click', clickEvent);
        }
    }
}

export default directive;